const cuveData = {
  slug: "cuv-e",
  name: "Honda CUV e:",

  hero: {
    shortDescription:
      "Motor listrik premium Honda dengan desain futuristik, teknologi pintar, dan performa ramah lingkungan",

    variants: [
      {
        key: "stellar-black",
        label: "Stellar",
        fullName: "Honda CUV e Stellar Matte Black",
        startPrice: 54450000,
      },
      {
        key: "roadsync-silver",
        label: "RoadSync Duo",
        fullName:
          "Honda CUV e RoadSync Duo Quantum Matte Silver",
        startPrice: 59650000,
      },
      {
        key: "roadsync-white",
        label: "RoadSync Duo",
        fullName:
          "Honda CUV e RoadSync Duo Quantum Matte White",
        startPrice: 59650000,
      },
    ],

    slides: [
      {
        variantKey: "stellar-black",
        image: "/assets/motor/produk/cuve/CUV-e-Stellar-Matte-Black.webp",
        specs: {
          engine: "Motor Listrik, In-Wheel Motor",
          power: "6 kW (Peak Power)",
          smartKey: true,
        },
      },
      {
        variantKey: "roadsync-silver",
        image: "/assets/motor/produk/cuve/CUV-e-RoadSync-Duo-Quantum-Matte-Silver.webp",
        specs: {
          engine: "Motor Listrik, In-Wheel Motor",
          power: "6 kW (Peak Power)",
          smartKey: true,
        },
      },
      {
        variantKey: "roadsync-white",
        image: "/assets/motor/produk/cuve/CUV-e-RoadSync-Duo-Quantum-Matte-White.webp",
        specs: {
          engine: "Motor Listrik, In-Wheel Motor",
          power: "6 kW (Peak Power)",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CUV e: merupakan motor listrik premium Honda yang dirancang untuk mobilitas urban modern dengan teknologi ramah lingkungan dan performa optimal.",
      },
      {
        type: "paragraph",
        text:
          "Menggunakan sistem baterai Honda Mobile Power Pack e:, CUV e: menghadirkan pengalaman berkendara yang senyap, responsif, dan bebas emisi.",
      },
      {
        type: "heading",
        text: "Desain Futuristik dan Modern",
      },
      {
        type: "paragraph",
        text:
          "Tampilan clean dan futuristik dipadukan dengan bodi ergonomis, sistem pencahayaan full LED, serta panel meter digital modern.",
      },
      {
        type: "heading",
        text: "Teknologi Pintar Honda",
      },
      {
        type: "paragraph",
        text:
          "Varian RoadSync Duo dilengkapi konektivitas Honda RoadSync Duo dan sistem baterai ganda untuk jarak tempuh lebih optimal.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Motor", "Motor Listrik (In-Wheel Motor)"],
      ["Daya Maksimum", "6 kW (Peak Power)"],
      ["Torsi Maksimum", "22 Nm"],
      ["Sistem Penggerak", "Direct Drive"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Dual Shock"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.889 x 664 x 1.101 mm"],
      ["Tinggi Jok", "760 mm"],
      ["Jarak Sumbu Roda", "1.310 mm"],
      ["Berat", "±117 kg (tanpa baterai)"],
    ],

    kapasitas: [
      ["Tipe Baterai", "Honda Mobile Power Pack e:"],
      [
        "Jumlah Baterai",
        "1 Unit (Stellar) / 2 Unit (RoadSync Duo)",
      ],
    ],

    kelistrikan: [
      ["Sistem Starter", "Electric"],
      ["Panel Meter", "Full Digital"],
      ["Sistem Kunci", "Honda Smart Key System"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CUV e:",
    items: [
      {
        title: "Motor Listrik Bertenaga",
        desc:
          "Motor listrik dengan akselerasi responsif dan karakter senyap tanpa emisi.",
      },
      {
        title: "Honda Mobile Power Pack e:",
        desc:
          "Sistem baterai swap yang praktis dan efisien untuk penggunaan harian.",
      },
      {
        title: "RoadSync Duo",
        desc:
          "Konektivitas pintar dengan smartphone untuk navigasi dan notifikasi. *Tipe RoadSync Duo.",
      },
      {
        title: "Dual Battery System",
        desc:
          "Menggunakan dua baterai untuk jarak tempuh lebih optimal. *Tipe RoadSync Duo.",
      },
      {
        title: "Full LED Lighting System",
        desc:
          "Pencahayaan full LED dengan tampilan futuristik dan visibilitas optimal.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital modern dengan informasi lengkap dan jelas.",
      },
      {
        title: "Honda Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system.",
      },
    ],
  },
};

export default cuveData;
